

































































































































































































import {Component, Watch, Vue} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import CheckBoxElement from '@/components/common/CheckBoxElement.vue';
import {Mall, GlobalMallHierarchy, Nullable, MallType} from 'supporter';
import { namespace } from 'vuex-class';

import ReasonDetailLayerPopup from '@/components/ReasonDetailLayerPopup.vue';

const mallModule = namespace('mall');
interface MallOption {
  value: number;
  label: string;
  globalMallType?: MallType;
  globalMallHierarchy?: Nullable<GlobalMallHierarchy>;
}

@Component({
  components: {
    PageTitle,
    RadioElement,
    CheckBoxElement,
    ReasonDetailLayerPopup
  }
})
export default class GroupAddForm extends Vue {
  private showIframe = process.env.VUE_APP_NODE_ENV !== 'production';

  @mallModule.Getter('mallsGlobal')
  private malls!: Mall[];

  private contentList: any = {}; // 获取到menuNo作为v-model的Value使用  contentList是整个v-model列表对象
  private menuList: number[][] = []; // menuNo 만 저장
  private menuOptions: {name: string, data: {id: string, value: string, display: string}[]}[][] = []; // menu 별 설정을 저장
  private kakaoFriendManagementMenuNo = Number(process.env.VUE_APP_KAKAO_FRIENDS_MENU_NO) || 0;
  private authorityGroupNo: any = '';
  // put请求体
  private requestBody: any = {
    pathParams: {
      authorityGroupNo: this.$route.params.authorityGroupNo
    },
    data: {
      menuAuthorities: null,
      name: '',
      description: '',
      allowsMarketingDirection: false,
      permitsPrivateInformation: false
    }
  };
  private updatePageNameValue: string = ''; // 修正页面初始Name
  private chooseaMallDisabled: boolean = false; // 쇼핑몰 선택 是否禁用的状态
  private authorityGroupValue: string = '';
  private groupDescriptionValue: string = '';
  private adminCount = 0;
  private reasonDetail = '';
  private renderList: any = null;

  // 개인정보 목록조회
  private permitsPrivateInformation: string = '';
  private permitsPrivateInformationOptions: any = {
    name: 'personal',
    data: [
      {
        id: 'possible',
        value: 'POSSIBLE',
        dispaly: `${this.$t('AUTHORITY_GROUP_ADDFORM_MAYBE_MAYBE')}`
      }
    ]
  };
  // 상품담당자
  private allowsMarketingDirection: string = '';
  private allowsMarketingDirectionOptions: any = {
    name: 'productManager',
    data: [
      {
        id: 'productManager',
        value: 'PRODUCTMANAGER',
        dispaly: `${this.$t('AUTHORITY_GROUP_ADDFORM_PRODUCTMANAGER')}`
      }
    ]
  };

  // 쇼핑몰 선택
  private chooseaMallArr: MallOption[] = [];
  private chooseMallStatusArr: number[] = [];
  // 三个显示状态
  private beUsableStatus: boolean = false;
  private authorityStatusNull: boolean = false;
  private repeatNametatus: boolean = false;
  private reasonDetailModal = { 
    type: 'EDIT',
    isOpen: false,
  };

  private globalSettingRadio = [
    {
      id: 'unlimited',
      value: 'UNLIMITED',
      display: '권한없음'
    },
    {
      id: 'query',
      value: 'QUERY',
      display: '조회'
    },
    {
      id: 'queryOrModify',
      value: 'QUERYORMODIFY',
      display: '조회/수정'
    }
  ];

  private closeReasonDetailModal() {
    this.reasonDetailModal.isOpen = false
  }

  private openReasonDetailModal(type: 'EDIT' | 'DELETE') {
    if (type ==='DELETE' && this.adminCount) {
      alert('운영자가 등록된 권한그룹은 삭제할 수 없습니다.');

      return;
    }

    this.reasonDetailModal.isOpen = true;
    this.reasonDetailModal.type = type;
  }

  private confirmReasonDetailModal(value: string) {
    this.reasonDetail = value;

    if (!this.reasonDetail) {
      alert('사유를 입력해주세요.');

      return;
    }

    this.closeReasonDetailModal();

    if (this.reasonDetailModal.type === 'EDIT') {
      this.putHandleClick()

      return;
    }

    this.delHandleClick()
  }

  /** 글로벌 몰 권한 체크 menuNo 리스트  */
  private get globalCheckMenus() {
    let product = [];
    let display = [];
    if (['development', 'local'].includes(process.env.VUE_APP_NODE_ENV)) {
      // 상품관리 > 상품정보 조회/수정(388), 상품등록(387), 상품심사(389), 표준카테고리수수료 관리(392), 상품재고 관리(8056) 조회 || 조회/수정 체크
      product = [388, 387, 389, 392, 8056];
      // 전시관리 > 전시카테고리 관리(416), 브랜드 관리(1252455), 전시상품 우선순위 관리(8314) 조회 || 조회/수정 체크
      display = [416, 1252455, 8314];
    }
    if (process.env.VUE_APP_NODE_ENV === 'production') {
      // 상품관리 > 상품정보 조회/수정(388), 상품등록(387), 상품심사(389), 표준카테고리수수료 관리(392), 상품재고 관리(5129) 조회 || 조회/수정 체크
      product = [388, 387, 389, 392, 5129];
      // 전시관리 > 전시카테고리 관리(416), 브랜드 관리(6799), 전시상품 우선순위 관리(5144) 조회 || 조회/수정 체크
      display = [416, 6799, 5144];
    }

    return { product, display };
  }

  /** 쇼핑몰 선택 */
  private handleMallCheckboxClick(e: Event, mall: MallOption) {
    const isChecked = (e.target as HTMLInputElement).checked;
      // 분리형 글로벌 몰 선택 체크해제 벨리데이션
    if (['SEPARATED_GLOBAL_MAIN', 'SEPARATED_GLOBAL_SUB'].includes(mall.globalMallType)) {
      const { product, display } = this.globalCheckMenus;

      const productGlobalAuth = this.renderList[0].menus?.filter((item) => product.includes(item.menuNo)).map(({menuNo, name}) => ({ menuNo, name }));
      const displayGlobalAuth = this.renderList[4].menus?.filter((item) => display.includes(item.menuNo)).map(({menuNo, name}) => ({ menuNo, name }));

      // 권한 체크
      const checkAuth = [...productGlobalAuth, ...displayGlobalAuth].filter(({ menuNo }) => ['QUERYORMODIFY', 'QUERY'].includes(this.contentList[menuNo])).map(({ name }) => name).join(',');

      if (checkAuth.length > 0) {
        if (!isChecked) {
          alert(`${checkAuth} 메뉴에 권한이 설정되어 해제 불가합니다.`);
          e.preventDefault();
          return;
        } else {
          // 선택하지 않은 몰 중 글로벌 몰이 있는 지 확인
          const unselectedGlobalMalls = this.malls.filter(mall => !this.chooseMallStatusArr.includes(mall.mallNo) && 
            ['SEPARATED_GLOBAL_MAIN', 'SEPARATED_GLOBAL_SUB'].includes(mall.globalMallType));

          if (unselectedGlobalMalls.length > 0){
            if (confirm('상품정보 조회/수정, 상품등록, 상품심사, 표준카테고리수수료 관리, 상품재고관리, 전시카테고리 관리, 브랜드 관리, 전시상품 우선순위 관리 메뉴 권한 설정은 글로벌 쇼핑몰 전체에 동일하게 적용됩니다. 적용하시겠습니까?')) {
              this.chooseMallStatusArr.push(...unselectedGlobalMalls.map(mall => mall.mallNo));

              // 체크박스 체크
              unselectedGlobalMalls.forEach(mall => {
                const checkbox = document.getElementById(`${mall.mallNo}`) as HTMLInputElement;
                if (checkbox) {
                  checkbox.checked = true;
                }
              });

            } else {
              e.preventDefault();
            }

            return;
          }
        }
      }
    }

    if (isChecked) {
      // 체크된 경우: 값 추가
      if (!this.chooseMallStatusArr.includes(mall.value)) {
        this.chooseMallStatusArr.push(mall.value);
      }
    } else {
      // 체크 해제된 경우: 값 제거
      const index = this.chooseMallStatusArr.indexOf(mall.value);
      if (index !== -1) {
        this.chooseMallStatusArr.splice(index, 1);
      }
    }
  }

  /** 글로벌 몰 모두 선택 유무 */
  private get isGlobalMallAllChecked() {
    const globalMalls = this.malls.filter((mall) => ['SEPARATED_GLOBAL_MAIN', 'SEPARATED_GLOBAL_SUB'].includes(mall.globalMallType));
    const globalMallNos = globalMalls.map(mall => mall.mallNo);

    return { allChecked: globalMallNos.every(mallNo => this.chooseMallStatusArr.includes(mallNo)), globalMallNos };
  }

  private handleAllSettingRadioClick({e, value, menuIndex, menuGroupName }: {e: Event, value: string, menuIndex: number, menuGroupName: string}) {
    const { allChecked, globalMallNos } = this.isGlobalMallAllChecked;
    
    if (menuGroupName === '상품관리' || menuGroupName === '전시관리') {
    // 글로벌 몰 조회 or 조회/수정 벨리데이션 체크
      if (!allChecked) {
        if (confirm('상품정보 조회/수정, 상품등록, 상품심사, 표준카테고리수수료 관리, 상품재고관리, 전시카테고리 관리, 브랜드 관리, 전시상품 우선순위 관리 메뉴 권한 설정은 글로벌 쇼핑몰 전체에 동일하게 적용됩니다. 적용하시겠습니까?')) {
          this.menuList[menuIndex].forEach((item) => {
            this.contentList[item] = value;
          });

          const uniqueMallNos = new Set([...this.chooseMallStatusArr, ...globalMallNos]);
          this.chooseMallStatusArr = Array.from(uniqueMallNos);

          return;
        } else {
          e.preventDefault();
          return;
        }
      }
    }

    this.menuList[menuIndex].forEach((item) => {
      this.contentList[item] = value;
    });

    if (menuGroupName === '운영관리') {
      if (value === 'QUERY') {
        this.contentList[this.kakaoFriendManagementMenuNo] = 'QUERYORMODIFY';
      }
    }
  }

  private handleMenuRadioClick({e, value, menuNo, menuGroupName }: {e: Event, value: string, menuNo: string, menuGroupName: string}) {
    const { product, display } = this.globalCheckMenus;
    const { allChecked, globalMallNos } = this.isGlobalMallAllChecked;
    const globalMenuNos = [...product, ...display];

    if (menuGroupName === '상품관리' || menuGroupName === '전시관리') {
      // 글로벌 몰 조회 or 조회/수정 벨리데이션 체크
      if (!allChecked && globalMenuNos.includes(Number(menuNo))) {
        if (confirm('상품정보 조회/수정, 상품등록, 상품심사, 표준카테고리수수료 관리, 상품재고관리, 전시카테고리 관리, 브랜드 관리, 전시상품 우선순위 관리 메뉴 권한 설정은 글로벌 쇼핑몰 전체에 동일하게 적용됩니다. 적용하시겠습니까?')) {
          this.contentList[menuNo] = value;

          const uniqueMallNos = new Set([...this.chooseMallStatusArr, ...globalMallNos]);
          this.chooseMallStatusArr = Array.from(uniqueMallNos);

          return;
        } else {
          e.preventDefault();
          return;
        }
      }
    }

    this.contentList[menuNo] = value;
  }

  // 查询권한그룹명 是否重复
  private authorityGroupClick() {
    if (!this.authorityGroupValue) {
      this.authorityStatusNull = true;
      this.beUsableStatus = false;
      this.repeatNametatus = false;
    } else {
      this.authorityStatusNull = false;
      this.$api.getAuthorityGroupsExists({params: {name: this.authorityGroupValue}}).then(res => {
        // 如果页面为修改时 允许同名 但是不能和别的相同
        if (['modifyForm', 'modifyFormPrev'].includes(this.$route.name)) {
          // 如果等于初始化Name可以使用当前名字
          if (this.updatePageNameValue === this.authorityGroupValue) {
            this.beUsableStatus = true;
            this.repeatNametatus = false;
          } else {
            // 不使用当前Name的情况下查询结果 返回False表示没有重复（可以使用）否则相反
            if (!res.data.exists) {
              this.beUsableStatus = true;
              this.repeatNametatus = false;
            } else {
              this.repeatNametatus = true;
              this.beUsableStatus = false;
            }
          }
        } else {
          // 如果时注册时不允许重复 返回False表示没有重复（可以使用）否则相反
          if (!res.data.exists) {
            this.beUsableStatus = true;
            this.repeatNametatus = false;
          } else {
            this.repeatNametatus = true;
            this.beUsableStatus = false;
          }
        }
      });
    }
  }

  private created() {
    // 获取mall 渲染成CheckBox
    this.malls.map(item => {
      this.chooseaMallArr.push({
        value: item.mallNo,
        label: item.mallName,
        globalMallType: item.globalMallType,
        globalMallHierarchy: item.globalMallHierarchy
      });
    });
    // 获取menu信息
    this.$api.getMenu().then(res => {
      this.renderList = res.data;
      
      for (let i = 0; i < res.data.length; i++) {
        this.menuList.push([]);
        this.menuOptions.push([]);
        res.data[i].menus.map((item: any) => {
          this.menuList[i].push(item.menuNo);
          this.menuOptions[i].push({
            name: item.name,
            data: [
              {
                id: `${item.menuNo}Unlimited`,
                value: 'UNLIMITED',
                display: '권한없음'
              },
              {
                id: `${item.menuNo}Query`,
                value: 'QUERY',
                display: '조회'
              },
              {
                id: `${item.menuNo}QueryOrModify`,
                value: 'QUERYORMODIFY',
                display: '조회/수정'
              }
            ]
          });
          // set拦截数据，实现数据更新改变功能
          this.$set(this.contentList, item.menuNo.toString(), 'UNLIMITED');
        });
      }
      // 检测URL是否为수정  /authorityGroup/modifyForm/{authorityGroupNo}
      if (['modifyForm', 'modifyFormPrev'].includes(this.$route.name)) {
        const getauthorityGroupsNoObj = {
          pathParams: {
            authorityGroupNo: this.$route.params.authorityGroupNo
          }
        };
        this.getInitializationDataMethod(getauthorityGroupsNoObj);
      }
      // 检测URL是否为 복사등록  /authorityGroup/addForm?authorityGroupNo={authorityGroupNo}
      if (this.$route.query.authorityGroupNo) {
        const getauthorityGroupsNoObj = {
          pathParams: {
            authorityGroupNo: this.$route.query.authorityGroupNo
          }
        };
        this.getInitializationDataMethod(getauthorityGroupsNoObj);
      }
    });
  }

  // 获取权限组数据 方法
  private getInitializationDataMethod(getauthorityGroupsNoObj) {
    this.$api.getAuthorityGroupsByGroupNo(getauthorityGroupsNoObj).then(res => {
      this.authorityGroupValue = res.data.name; // 권한그룹명 修改
      this.updatePageNameValue = res.data.name;
      this.groupDescriptionValue = res.data.description; // 권한그룹 설명 修改
      this.adminCount = res.data.adminCount; // 권한그룹 설명 修改
      // 判断개인정보 목록조회 / 상품담당자的选中状态
      if (res.data.permitsPrivateInformation) {
        this.permitsPrivateInformation = 'POSSIBLE';
      } else {
        this.permitsPrivateInformation = '';
      }
      if (res.data.allowsMarketingDirection) {
        this.allowsMarketingDirection = 'PRODUCTMANAGER';
      } else {
        this.allowsMarketingDirection = '';
      }
      if (['modifyForm', 'modifyFormPrev'].includes(this.$route.name)) {
        this.chooseMallStatusArr = res.data.mallNos; // 쇼핑몰 선택
        // this.chooseaMallDisabled = true; // 쇼핑몰 선택checkbox禁用
      }

      // 메뉴 권한权限判断并渲染
      res.data.menuAuthorities.map(item => {
        if (item.readable && item.writable) {
          this.contentList[item.menuNo] = 'QUERYORMODIFY';
        } else if (item.readable && !item.writable) {
          this.contentList[item.menuNo] = 'QUERY';
        } else if (!item.readable && !item.writable) {
          this.contentList[item.menuNo] = 'UNLIMITED';
        }
        item.menuNo;
      });
    });
  }
  // for router.push don't fresh page.
  @Watch('$route')
  routechange(to: any, from: any) {
    // to copy group page
    //this.$router.go(0);
    if (to.path !== from.path) {  
      this.chooseMallStatusArr = []; // reset 쇼핑몰 선택
      this.chooseaMallDisabled = false; // enabled 쇼핑몰 선택checkbox
      //scroll to top.
      document.getElementById('wrap').scrollIntoView(); 
    }
  }
  // computed get （如果这一组radio都选择相同的一个value 全选按钮为选中状态）
  private getValueFn(list: any) {
    const values = this.contentList;
    let UNLIMITED = 0;
    let QUERY = 0;
    let QUERYORMODIFY = 0;
    list.map(item => {
      if (values[item] === 'UNLIMITED') {
        UNLIMITED++;
      } else if (values[item] === 'QUERY') {
        QUERY++;
      } else if (values[item] === 'QUERYORMODIFY') {
        QUERYORMODIFY++;
      }
    });
    if (UNLIMITED === list.length) {
      return 'UNLIMITED';
    } else if (QUERY === list.length) {
      return 'QUERY';
    } else if (QUERYORMODIFY === list.length) {
      return 'QUERYORMODIFY';
    } else {
      return '';
    }
  }

  // computed set （全选按钮为选中状态时 对应该组所有radio选中相同value）
  private setValueFn(val: any, list: any) {
    const values = this.contentList;
    if (val === 'UNLIMITED') {
      list.forEach(ele => {
        values[ele] = 'UNLIMITED';
      });
    }
    if (val === 'QUERY') {
      list.forEach(ele => {
        values[ele] = 'QUERY';
      });
    }
    if (val === 'QUERYORMODIFY') {
      list.forEach(ele => {
        values[ele] = 'QUERYORMODIFY';
      });
    }
  }

  // 권한그룹 삭제
  private delHandleClick() {
    const delauthorityGroupsNoObj = {
      pathParams: {
        authorityGroupNo: this.$route.params.authorityGroupNo
      },
      params: {
        reasonDetail: this.reasonDetail,
      }
    };
    if (window.confirm(`${this.$t('AUTHORITY_GROUP_ADDFORM_WANT_TO_DELETE_THIS_PERMISSION_GROUP')}`)) {
      this.$api.deleteAuthorityGroupsByGroupNo(delauthorityGroupsNoObj).then(res => {
        if (res.status === 204) {
          // 删除 权限组 如果成功返回 204
          alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_THE_PERMISSION_GROUP_HAS_BEEN_DELETED')}`);
          this.$router.push('/authorityGroup/list');
        }
      });
      return true;
    } else {
      return false;
    }
  }
  // 취소
  private cancelHandleClick() {
    if (window.confirm(`${this.$t('AUTHORITY_GROUP_ADDFORM_UNREGISTER_THE_PERMISSION_GROUP')}`)) {
      this.$router.push('/authorityGroup/list');
      return true;
    } else {
      return false;
    }
  }
  // 권한그룹 복사등록
  private copyHandleClick() {
    this.$router.push(`/authorityGroup/addForm?authorityGroupNo=${this.$route.params.authorityGroupNo}`);
  }
  // 등록
  private registerHandleClick() {
    if (this.beUsableStatus) {
      if (this.chooseMallStatusArr.length === 0) {
        alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_NO_SHOPPING_CENTERS_TO_CHOOSE_FROM')}`);
        return;
      }

      if (!this.reasonDetail) {
        alert('사유를 입력해주세요.');
        return;
      }

      if(!this.hasSelectAuth()) {
        alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_NO_AUTH_SELECT')}`); 
        return;
      }
      this.authorityListMethod('post'); // 增加选权限函数 执行
    } else if (this.repeatNametatus) {
      alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_PLEASE_CONFIRM_THE_PERMISSION_GROUP_NAME_AGAIN')}`);
    } else {
      alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_PLEASE_CONFIRM_THE_PERMISSION_GROUP_NAME_AGAIN')}`);
      return;
    }
  }
  // 변경사항 저장
  private putHandleClick() {
    if (this.beUsableStatus) {
      if(!this.hasSelectAuth()) {
        alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_NO_AUTH_SELECT')}`); 
        return;
      }

      this.authorityListMethod('put'); // 修改选权限函数 执行
    } else if (this.repeatNametatus) {
      alert('');
    } else {
      alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_PLEASE_CONFIRM_THE_PERMISSION_GROUP_NAME_AGAIN')}`);
      return;
    }
  }
  private changeChkMsgStatus() {
    this.beUsableStatus = false;
    this.repeatNametatus = false;
    if (['modifyForm', 'modifyFormPrev'].includes(this.$route.name)) {
        if (this.updatePageNameValue === this.authorityGroupValue) {
          this.beUsableStatus = true;
        }
    }
    if (this.authorityGroupValue) {
      this.authorityStatusNull = false;
    }else {
      this.authorityStatusNull = true;
    }
  }

  // 修改选权限函数
  private authorityListMethod(type: string) {
    this.requestBody.data.menuAuthorities = this.valueConvertObj();
    this.requestBody.data.name = this.authorityGroupValue;
    this.requestBody.data.description = this.groupDescriptionValue;
    this.requestBody.data.allowsMarketingDirection = this.allowsMarketingDirection === 'PRODUCTMANAGER' ? true : false;
    this.requestBody.data.permitsPrivateInformation = this.permitsPrivateInformation === 'POSSIBLE' ? true : false;
    this.requestBody.data.reasonDetail = this.reasonDetail
    this.requestBody.data.mallNos = this.chooseMallStatusArr;

    // 区分注册/修正
    if (type === 'put') {
      if (window.confirm(`${this.$t('AUTHORITY_GROUP_ADDFORM_COMPLETE_THE_REGISTRATION_OF_PERMISSION_GROUP')}`)) {
        this.$api.putAuthorityGroupsByGroupNo(this.requestBody).then(res => {
          if (res.status === 204) {
            // 如果成功返回list
            alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_CHANGES_HAVE_BEEN_SAVED')}`);
            this.$router.push('/authorityGroup/list');
          } else {
            alert('');
          }
        });
        return true;
      } else {
        return false;
      }
    } else if (type === 'post') {
      if (window.confirm(`${this.$t('AUTHORITY_GROUP_ADDFORM_COMPLETE_THE_REGISTRATION_OF_PERMISSION_GROUP')}`)) {
        this.$api.postAuthorityGroups(this.requestBody).then(res => {
          if (res.status === 201) {
            alert(`${this.$t('AUTHORITY_GROUP_ADDFORM_NEW_PERMISSION_GROUP_HAS_BEEN_REGISTERED_NORMALLY')}`);
            this.$router.push('/authorityGroup/list');
          }
        });
        return true;
      } else {
        return false;
      }
    }
  }

  private hasSelectAuth() : boolean {
    let flg  = false;
    for (const key in this.contentList) {
       if (this.contentList[key] !== 'UNLIMITED') {
         flg = true;
         break;
       }
    }
    return flg;
  }

  // v-model列表对象 转化 请求需要的对象格式
  private valueConvertObj() {
    const temporaryArray = [];
    for (const key in this.contentList) {
      if (this.contentList[key] === 'UNLIMITED') {
        temporaryArray.push({
          menuNo: key,
          readable: false,
          writable: false
        });
      } else if (this.contentList[key] === 'QUERY') {
        temporaryArray.push({
          menuNo: key,
          readable: true,
          writable: false
        });
      } else {
        temporaryArray.push({
          menuNo: key,
          readable: true,
          writable: true
        });
      }
    }
    return temporaryArray;
  }
}
